<template>
  <component
    @show-enlarged="showEnlarged"
    :is="`${node.data.object.type}-widget`"
    :widget="node.data"
  />
</template>

<script>
  import LayerWidget from '@/components/templates/viewer/templateWidgets/LayerWidget.vue';
  import TextWidget from '@/components/templates/viewer/templateWidgets/TextWidget.vue';
  import ClockWidget from '@/components/templates/viewer/templateWidgets/ClockWidget.vue';
  import ButtonWidget from '@/components/templates/viewer/templateWidgets/ButtonWidget.vue';
  import ImageWidget from '@/components/templates/viewer/templateWidgets/ImageWidget.vue';
  import AppWidget from '@/components/templates/viewer/templateWidgets/AppWidget.vue';
  import VideoWidget from '@/components/templates/viewer/templateWidgets/VideoWidget.vue';
  import PdfWidget from '@/components/templates/viewer/templateWidgets/PdfWidget.vue';
  import RichtextWidget from '@/components/templates/viewer/templateWidgets/RichTextWidget.vue';
  import AudioWidget from '@/components/templates/viewer/templateWidgets/AudioWidget.vue';
  import TenantWidget from '@/components/templates/viewer/templateWidgets/TenantsWidget.vue';
  import TrafiklabWidget from '@/components/templates/viewer/templateWidgets/TrafiklabWidget.vue';
  import WeatherWidget from '@/components/templates/viewer/templateWidgets/WeatherWidget.vue';
  import RssWidget from '@/components/templates/viewer/templateWidgets/RssWidget.vue';
  import LinkWidget from '@/components/templates/viewer/templateWidgets/LinkWidget.vue';
  import TableWidget from '@/components/templates/viewer/templateWidgets/TableWidget.vue';
  import TimeWidget from '@/components/templates/viewer/templateWidgets/TimeWidget.vue';
import DateWidget from '@/components/templates/viewer/templateWidgets/DateWidget.vue';

  export default {
    name: 'WidgetNode',
    props: {
      node: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      showEnlarged(w) {
        this.$emit('show-enlarged', w);
      },
    },
    components: {
      AudioWidget,
      ImageWidget,
      LayerWidget,
      TextWidget,
      ClockWidget,
      ButtonWidget,
      AppWidget,
      VideoWidget,
      PdfWidget,
      RichtextWidget,
      TenantWidget,
      WeatherV2Widget: WeatherWidget,
      TrafiklabV2Widget: TrafiklabWidget,
      RssV2Widget: RssWidget,
      LinkWidget,
      TableV2Widget: TableWidget,
      TimeWidget,
      DateWidget,
    },
  };
</script>

<style scoped></style>
